import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { PurchaseMethodFlow, SupportingEvidenceFlow, TicketPurchasedFlow } from '../../pageFlowData'
import { data } from './data'

export const TicketPurchased: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    ticket: { ticketPurchased },
  } = state

  const handleStepChoice = (value: string) => {
    if (value === 'yes') {
      return { progress: PurchaseMethodFlow.PROGRESS_VALUE, step: PurchaseMethodFlow.STEP }
    }

    return { progress: SupportingEvidenceFlow.PROGRESS_VALUE, step: SupportingEvidenceFlow.STEP }
  }

  const handleDispatch = (value: string) => {
    const { progress, step } = handleStepChoice(value)

    dispatch({ type: 'UPDATE_TICKET_PURCHASED', data: value })
    dispatch({ type: 'UPDATE_STEP', data: step })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: progress })
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${TicketPurchasedFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleSubmit = (id: string) => {
    handleDispatch(id)
    handleTracking(id)
  }

  const { buttons, imgObj, title } = data

  return (
    <div data-testid="ticket-purchased">
      <PillButtonPage
        buttons={buttons}
        defaultValue={ticketPurchased}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
